const t = "devtools-plugin:setup", s = "plugin:settings:set";
export {
  s as HOOK_PLUGIN_SETTINGS_SET,
  t as HOOK_SETUP
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/@vue_devtools-api@6.6.4/~/@vue/devtools-api/lib/esm/const.js
// module id = 836
// module chunks = 41